import { ParseQuery } from './parse-query';

import { BusinessCategory } from './../data';

export class BusinessCategoryQuery extends ParseQuery<BusinessCategory> {
  constructor() {
    super(BusinessCategory);
  }
}